export default __webpack_public_path__ + "assets/models/94a8eb45d67e076ed3901cace899416d.glb";